export default __webpack_public_path__ + "static/media/help-three.47d54c65.png";